export default __webpack_public_path__ + "static/media/retail.e4fe2ca6.png";